import { render, staticRenderFns } from "./applyMoney.vue?vue&type=template&id=06c45e96&scoped=true&"
import script from "./applyMoney.vue?vue&type=script&lang=js&"
export * from "./applyMoney.vue?vue&type=script&lang=js&"
import style0 from "./applyMoney.vue?vue&type=style&index=0&id=06c45e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c45e96",
  null
  
)

export default component.exports